export default __webpack_public_path__ + "static/ttf-05bb74e1f86b1fa659218c65e08c3cee.webp";